module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Menu-icon_red-bfa01c8a161e901458cad229bb9d426c.svg";